export const CHANGE_THEME = 'pulp/theme/CHANGE_THEME';

export const initialState = {};

const ThemeDuck = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_THEME:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default ThemeDuck;

export const changeTheme = (payload) => ({
  type: CHANGE_THEME,
  payload,
});
